export class JobProgressStepUserWorkloadRestorationData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "userId",
            "baseName": "userId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepUserWorkloadRestorationData.attributeTypeMap;
    }
    constructor() {
    }
}
